// Ubicación en el repo: src/pages/AurentecInfo.jsx
// Página pública — /audifonos-aurentec (30-sep-2026, DECISIONS.md #128,
// pedido de Nicolás: "debemos crear una página que tenga la información de
// los audífonos aurentec", para que el logo de Aurentec en la sección de
// Alianzas de PublicLanding.jsx tenga un destino real).
//
// Ruta pública, SIN sesión, fuera de RequireAuth/Layout — mismo criterio
// que PublicLanding/PublicScheduling. Contenido (nombres de modelo, specs,
// colores disponibles, textos de feature) transcrito de los 3 flyers de
// marketing que Nicolás compartió — no son datos inventados por Claude.
// Fotos de producto: recortadas de esos mismos flyers (public/aurentec-*.jpg),
// solo el dispositivo/estuche, sin el texto de marketing superpuesto.
import { Link } from 'react-router-dom';

const MODELOS = [
  {
    id: 'aur-cic',
    codigo: 'AUR-CIC',
    tipo: 'CIC · Recargable',
    foto: '/aurentec-aur-cic.jpg',
    titulo: 'Diseño compacto, discreto y pensado en tu comodidad.',
    features: ['Recargables sin pilas', 'Sonido nítido y natural', 'Ligeros y discretos', 'Ahorro sin pagar de más'],
    colores: ['Beige', 'Bicolor (Rojo / Azul)'],
    extra: { titulo: 'Mejor precio', desc: 'Una excelente relación calidad-precio.' },
  },
  {
    id: 'aur-ac',
    codigo: 'AUR-AC',
    tipo: 'RIC · Recargable',
    foto: '/aurentec-aur-ac.jpg',
    titulo: 'Tecnología avanzada en un diseño compacto y elegante.',
    features: [
      'Recargables sin pilas',
      'Sonido nítido y natural',
      'Personalización mediante APP',
      'Ligeros y discretos',
      'Confort todo el día',
    ],
    colores: ['Beige', 'Gris'],
    extra: { titulo: 'Autoajuste mediante APP', desc: 'Mayor control y personalización en tu smartphone.' },
  },
  {
    id: 'aur-rc',
    codigo: 'AUR-RC',
    tipo: 'RIC · Recargable · Premium',
    foto: '/aurentec-aur-rc.jpg',
    titulo: 'Tecnología Premium con un avanzado diseño y más altas prestaciones.',
    features: [
      'Carga eficiente y rápida',
      'Sonido nítido y natural',
      'Ligeros y discretos',
      'Personalización mediante APP',
      'Confort todo el día',
    ],
    colores: ['Beige', 'Gris'],
    extra: { titulo: 'Respaldo profesional', desc: 'Acompañamiento experto cuando más lo necesites y ajuste personalizado según lo necesites.' },
  },
];

function ModelCard({ modelo }) {
  return (
    <div className="aurentec-card">
      <img src={modelo.foto} alt={`Audífono Aurentec ${modelo.codigo}`} className="aurentec-card__photo" />
      <div className="aurentec-card__body">
        <div className="aurentec-card__head">
          <span className="aurentec-card__codigo">{modelo.codigo}</span>
          <span className="aurentec-card__tipo">{modelo.tipo}</span>
        </div>
        <p className="aurentec-card__titulo">{modelo.titulo}</p>

        <ul className="aurentec-card__features">
          {modelo.features.map((f) => (
            <li key={f}>{f}</li>
          ))}
        </ul>

        <div className="aurentec-card__colores">
          <span className="k">Disponible en</span>
          <span className="v">{modelo.colores.join(' · ')}</span>
        </div>

        <div className="aurentec-card__extra">
          <strong>{modelo.extra.titulo}</strong>
          <span>{modelo.extra.desc}</span>
        </div>
      </div>
    </div>
  );
}

export default function AurentecInfo() {
  return (
    <div className="landing-page aurentec-page">
      <header className="landing-header">
        <div className="landing-header__brand">
          <strong>Agenda Comunal</strong>
          <span className="landing-header__sub">by GlobalVision</span>
        </div>
        <img src="/agendadock-logo.png" alt="AgendaDock" className="landing-header__powered-logo" />
        <div className="landing-header__actions">
          <Link to="/login" className="landing-header__login">
            Acceso profesionales
          </Link>
        </div>
      </header>

      <main>
        <section className="aurentec-hero">
          <img src="/logo-aurentec.png" alt="Aurentec" className="aurentec-hero__logo" />
          <h1>
            Escucha más. <span>Vive mejor.</span>
          </h1>
          <p>
            Audífonos recargables sin pilas, diseñados para tu día a día. Conoce los modelos Aurentec disponibles
            en nuestras ópticas comunales y agenda una hora para que un profesional te ayude a elegir el que
            mejor se adapte a ti.
          </p>
          <Link to="/agendamiento-online" className="button-primary aurentec-hero__cta">
            Agendar una hora
          </Link>
        </section>

        <section className="aurentec-models">
          {MODELOS.map((m) => (
            <ModelCard key={m.id} modelo={m} />
          ))}
        </section>

        <section className="aurentec-back">
          <Link to="/" className="landing-hero__cta-ghost">
            ← Volver al inicio
          </Link>
        </section>
      </main>

      <footer className="landing-footer">
        <img src="/agendadock-logo.png" alt="AgendaDock" className="landing-footer__logo" />
        <p className="landing-footer__brand">Agendadock®</p>
        <p className="landing-footer__rights">Todos los derechos reservados.</p>
      </footer>
    </div>
  );
}
